import { CellphoneWirelessIcon } from './CellphoneWirelessIcon';

/**
 * author: Austin Andrews
 * id 071CA76A-0ED5-42CD-9BE9-46AFA9D5459E
 * name cellphone-wireless
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-wireless.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const SmartphoneWirelessIcon = CellphoneWirelessIcon;
export default SmartphoneWirelessIcon